import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDiaryDate, getRelativeDayKey } from '@/utils/date';

interface Props {
  date: string;
}

export const DiaryDateRow: React.FC<Props> = ({ date }) => {
  const { t } = useTranslation();
  const relativeDayKey = getRelativeDayKey(new Date(date));

  return (
    <p className="py-4 pr-5 pl-6 text-callout-16 text-foreground">
      {formatDiaryDate(date)}
      {relativeDayKey && ` (${t(relativeDayKey)})`}
    </p>
  );
};
